module.exports = __webpack_public_path__ + "img/airklima-shop-ipad.25b96d97.png";